import React from "react";
import CANDIDATE_SITES from "../data/sites";
import { DATA_FEED_ENDPOINTS, VERIFICATION_REFERENCE_LINKS } from "../config/dataSources";

export default function DataSourcesSection({ title = "Verify against primary sources", className = "" }) {
  return (
    <section
      className={`rounded-ds-xl border border-border bg-canvas-subtle p-4 ${className}`}
      aria-labelledby="data-sources-heading"
    >
      <h2 id="data-sources-heading" className="mb-3 text-xs font-semibold uppercase tracking-wide text-fg-tertiary">
        {title}
      </h2>
      <ul className="mb-3 grid gap-2 sm:grid-cols-2">
        {DATA_FEED_ENDPOINTS.map((ds) => (
          <li key={ds.name} className="flex flex-wrap items-start justify-between gap-2 rounded-ds border border-border bg-surface px-3 py-2 text-xs">
            <div>
              <div className="font-medium text-fg">{ds.name}</div>
              <div className="text-[10px] text-fg-tertiary">{ds.dataset}</div>
              <span className="mt-1 inline-flex rounded-full bg-success/10 px-2 py-0.5 text-[9px] font-semibold uppercase text-success">Fact-check</span>
            </div>
            <div className="flex shrink-0 flex-col items-end gap-1">
              <a href={ds.url} target="_blank" rel="noopener noreferrer" className="text-accent hover:underline">
                Portal
              </a>
              {ds.apiDocUrl && (
                <a href={ds.apiDocUrl} target="_blank" rel="noopener noreferrer" className="text-[10px] text-fg-tertiary hover:text-accent hover:underline">
                  API / doc
                </a>
              )}
            </div>
          </li>
        ))}
      </ul>
      <ul className="grid gap-1.5 sm:grid-cols-2">
        {VERIFICATION_REFERENCE_LINKS.map((e) => (
          <li key={e.url}>
            <a href={e.url} target="_blank" rel="noopener noreferrer" className="text-xs text-accent hover:text-accent-hover hover:underline">
              {e.name}
            </a>
          </li>
        ))}
      </ul>
      <p className="mt-3 text-[10px] text-fg-tertiary">Site coordinates in this app are representative points for {CANDIDATE_SITES.length} candidate areas.</p>
    </section>
  );
}
